(()=>{
  const MAX=1;
  const IDS=new Set('58434737144140 58434737176908 58434737209676 58434737242444 58434737275212 58434737307980 58434737340748 58434739142988 58434739175756 58434739208524 58434739241292 58434739274060 58434739306828 58434739732812 58434739765580 58434739798348 58434739831116'.split(' '));
  const cartQty={},cartLines={},plusLocks={};
  let syncing=false,normalizing=false;

  const css=document.createElement('style');
  css.textContent='.hdt-page-type-product .hdt-price,.hdt-page-type-product .hdt-price-wrapp{color:#f2f2f3!important;opacity:1!important}.ad-max3-note{margin-top:6px;font-size:11px;line-height:1.35;color:#c9cbd1}.ad-max3-cart-note{font-size:10px;font-weight:700;color:#7a2d42;margin-top:4px}';
  document.head.appendChild(css);

  function formOf(el){return el&&el.closest?el.closest('form'):null}
  function lineRoot(el){return el&&el.closest?el.closest('tr.hdt-cart-item,.hdt-cart-item,.hdt-mini-cart__item,.hdt-page-cart__item,hdt-line-item'):null}
  function cartInput(el){const line=lineRoot(el);return line&&line.querySelector('input[data-index][name="updates[]"],input[will-change-cart][data-index],input.hdt-quantity-input[data-index]')}
  function lineVariant(el){const i=cartInput(el);return i?String(cartLines[String(i.dataset.index)]||''):''}
  function variantId(el){if(!el)return'';const direct=el.closest&&el.closest('[data-variant-id]');if(direct&&direct.dataset.variantId)return String(direct.dataset.variantId);const f=formOf(el),x=f&&f.querySelector('input[name="id"]');if(x&&x.value)return String(x.value);return lineVariant(el)}
  function isCartQty(i){return !!(i&&i.matches&&i.matches('input[data-index][name="updates[]"],input[will-change-cart][data-index],input.hdt-quantity-input[data-index]'))}
  function quantityInput(el){const wrap=el&&el.closest&&el.closest('.hdt-quantity-cart-item,hdt-quantity-wrapp,.hdt-quantity-wrapp');const wi=wrap&&wrap.querySelector('input[type="number"]');if(wi)return wi;const c=cartInput(el);if(c)return c;const f=formOf(el);return f&&f.querySelector('input[name="quantity"],input[type="number"]')}

  function note(el){const f=formOf(el);if(!f)return;let n=f.querySelector('.ad-max3-note');if(!n){n=document.createElement('div');n.className='ad-max3-note';const anchor=f.querySelector('.hdt-product-form__buttons,.hdt-quantity-wrapp')||f;anchor.appendChild(n)}n.textContent='Maximum 1 per colour.';clearTimeout(n._t);n._t=setTimeout(()=>n.remove(),2200)}
  function cartNote(el){const root=lineRoot(el);if(!root)return;let n=root.querySelector('.ad-max3-cart-note');if(!n){n=document.createElement('div');n.className='ad-max3-cart-note';const q=root.querySelector('.hdt-mini-cart__quantity,.hdt-page-cart__quantity,.hdt-quantity-cart-item')||root;n.textContent='Maximum 1 per colour.';q.appendChild(n)}clearTimeout(n._t);n._t=setTimeout(()=>n.remove(),1800)}

  async function normalizeAggregate(items){
    if(normalizing)return false;
    const remaining={},changes=[];
    (items||[]).forEach(i=>{
      const id=String(i.variant_id);
      if(!IDS.has(id))return;
      const q=Math.max(0,Number(i.quantity||0));
      const left=remaining[id]===undefined?MAX:remaining[id];
      const keep=Math.max(0,Math.min(q,left));
      remaining[id]=Math.max(0,left-keep);
      if(keep!==q)changes.push({key:i.key,quantity:keep,id});
    });
    if(!changes.length)return false;
    normalizing=true;
    try{
      for(const c of changes){
        const r=await fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:c.key,quantity:c.quantity})});
        if(!r.ok)throw new Error('Unable to enforce cart limit');
      }
      location.reload();
      return true;
    }catch(e){
      return false;
    }finally{normalizing=false}
  }

  async function syncCart(){
    if(syncing||normalizing)return;
    syncing=true;
    try{
      const r=await fetch('/cart.js',{credentials:'same-origin'}),d=await r.json();
      if(await normalizeAggregate(d.items||[]))return;
      Object.keys(cartQty).forEach(k=>delete cartQty[k]);
      Object.keys(cartLines).forEach(k=>delete cartLines[k]);
      (d.items||[]).forEach((i,n)=>{const id=String(i.variant_id);cartQty[id]=(cartQty[id]||0)+Number(i.quantity||0);cartLines[String(n+1)]=id});
    }catch(e){}finally{syncing=false}
  }

  function clampOne(i){
    const id=variantId(i);if(!IDS.has(id))return;
    const cart=isCartQty(i);let max=MAX;
    if(!cart){max=Math.max(1,MAX-Number(cartQty[id]||0))}
    i.max=max;i.setAttribute('max',String(max));
    if(cart)i.dataset.max=String(MAX);
    if(Number(i.value)>max)i.value=max;
    const wrap=i.closest('.hdt-quantity-cart-item,hdt-quantity-wrapp,.hdt-quantity-wrapp');
    const plus=wrap&&wrap.querySelector('button[name="plus"],.is--plus,.hdt-quantity__plus,[data-quantity-plus]');
    if(plus){const blocked=cart?Number(cartQty[id]||0)>=MAX:Number(i.value)>=max;plus.classList.toggle('disabled',blocked);plus.setAttribute('aria-disabled',blocked?'true':'false')}
  }
  function clampVisible(){document.querySelectorAll('form input[name="quantity"],form input[type="number"],input[data-index][name="updates[]"],input[will-change-cart][data-index],input.hdt-quantity-input[data-index]').forEach(clampOne)}

  document.addEventListener('input',e=>{
    const i=e.target;if(!i.matches||!i.matches('input[name="quantity"],input[type="number"],input[data-index][name="updates[]"],input[will-change-cart][data-index],input.hdt-quantity-input[data-index]'))return;
    const id=variantId(i);if(!IDS.has(id))return;
    const cart=isCartQty(i),max=cart?MAX:Math.max(1,MAX-Number(cartQty[id]||0));
    if(Number(i.value)>max){i.value=max;cart?cartNote(i):note(i)}
  },true);

  document.addEventListener('click',e=>{
    const b=e.target.closest&&e.target.closest('button,a');if(!b)return;
    const isPlus=b.matches('button[name="plus"],.hdt-quantity__plus,.plus,[data-quantity-plus],.is--plus');
    if(isPlus){
      const i=quantityInput(b),id=variantId(b);if(!i||!IDS.has(id))return;
      const cart=isCartQty(i);
      if(cart){
        const now=Date.now(),total=Number(cartQty[id]||0);
        if(total>=MAX||Number(i.value)>=MAX||Number(plusLocks[id]||0)>now){e.preventDefault();e.stopImmediatePropagation();if(total>=MAX||Number(i.value)>=MAX)cartNote(b);return}
        plusLocks[id]=now+750;
        setTimeout(()=>syncCart().then(clampVisible),500);
        return;
      }
      const max=Math.max(1,MAX-Number(cartQty[id]||0));i.max=max;i.setAttribute('max',String(max));
      if(Number(i.value)>=max){e.preventDefault();e.stopImmediatePropagation();i.value=max;note(b)}
      return;
    }
    const add=b.matches('button[name="add"],.hdt-product-form__submit,.hdt-pr-btn-atc,[data-add-to-cart]');if(!add)return;
    const id=variantId(b);if(!IDS.has(id))return;
    const i=quantityInput(b),wanted=Math.max(1,Number(i&&i.value||1)),already=Number(cartQty[id]||0),left=MAX-already;
    if(left<=0){e.preventDefault();e.stopImmediatePropagation();note(b);return}
    if(i&&wanted>left){i.value=left;note(b)}
    cartQty[id]=already+Math.min(wanted,left);
    setTimeout(()=>syncCart().then(clampVisible),700);
  },true);

  document.addEventListener('change',e=>{if(e.target&&e.target.matches&&e.target.matches('input[data-index][name="updates[]"],input[will-change-cart][data-index],input.hdt-quantity-input[data-index]'))setTimeout(()=>syncCart().then(clampVisible),350)},true);
  window.addEventListener('pageshow',()=>syncCart().then(clampVisible));
  syncCart().then(clampVisible);
  setInterval(()=>{clampVisible();if(document.querySelector('#CartDrawer,.hdt-mini-cart,#hdt-page-cart'))syncCart()},650);
})();